import styled from 'styled-components'
import { themeGet } from "@styled-system/theme-get";

export const BannerWrapper = styled.div`
    background-image: white;
    display: flex;
    align-items: center;
    justify-content: center;
    // padding: 10px;
    width: 100%;
    height: auto;
    margin: 20px 10px;
    cursor: pointer;
    li.react-multi-carousel-item   {
        padding: 20px;
    }
    ul.react-multi-carousel-dot-list   {
        margin-bottom: 20px;
    }
    .w-dev{
        width: 100%;
    }
    @media screen and (max-width: 722px) {
        display: inline-block;
        margin: 20px 0;
    }
`;

export const BannerDiv = styled.div`
    height: 270px;
    width: 100%;
    border-radius: 20px;
    position: relative;
    margin: 10px;
    &:hover{
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    }
    &.mobile {
        margin: 0;
    }
    img{
        border-radius: 20px;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    @media screen and (max-width: 922px) {
        width: 100%;
    }
    @media screen and (min-width: 2240px) {
        height: 450px;
    }
    @media screen and (max-width: 2240px) {
        height: 415px;
    }
    @media screen and (max-width: 2040px) {
        height: 375px;
    }
    @media screen and (max-width: 1840px) {
        height: 335px;
    }
    @media screen and (max-width: 1640px) {
        height: 300px;
    }
    @media screen and (max-width: 1440px) {
        height: 235px;
    }
    @media screen and (max-width: 1024px) {
        height: 170px;
    }
    @media screen and (max-width: 425px) {
        height: 140px;
    }
`;

export const TitleDiv = styled.div`
    margin: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Title = styled.h1`
    font-weight: 800;
    text-transform: capitalize;
    color: white;
    font-size: 3.5rem;
    /* -webkit-text-stroke: 2px #9CC54B; */
    text-shadow: 2px 2px 0 #9cc54b, 2px 2px 0 #9cc54b, 2px 2px 0 #9cc54b, 2px 2px 0 #9cc54b;
    @media screen and (max-width: 1250px) {
        font-size:2.5rem;
    }

    @media screen and (max-width: 920px) {
        font-size: 3.5rem;
    }

    @media screen and (max-width: 930px) {
        font-size: 2.5rem;
        width: 100%;
        text-align: center;
    }
    @media screen and (max-width: 720px) {
        font-size: 2.5rem;
        width: 100%;
        text-align: center;
    }

     @media screen and (max-width: 400px) {
        font-size: 2rem;
    }
  
`;


export const Prev = styled("button")`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(250,250,250,0.8);
  color: ${themeGet("colors.primary", "#9cc54b")};
  padding: 0;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border: 0;
  outline: 0;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -20px;
  z-index: 99;
  @media screen and (max-width: 720px) {
    display: none;
  }
`;

export const Next = styled("button")`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(250,250,250,0.8);
  color: ${themeGet("colors.primary", "#9cc54b")};
  padding: 0;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border: 0;
  outline: 0;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -20px;
  z-index: 99;
  @media screen and (max-width: 720px) {
    display: none;
  }
`;
export const Wrapper = styled("div")`
`;

export const Notfound = styled("div")`
width: 100%;
padding: 20px;
text-align: center;
`;